import NewProjectCreateLayout from 'features/ngo/projects/CreateProject'

const NGOProjectCreate = () => {
  return (
    <NewProjectCreateLayout />
  )
}

export default NGOProjectCreate